var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.725 5.55476L1.725 0.054759C1.63879 0.0116424 1.54195 -0.0056335 1.44614 0.00501157C1.35034 0.0156566 1.25965 0.0537688 1.185 0.114759C1.11372 0.174505 1.06051 0.252952 1.03136 0.341281C1.00221 0.42961 0.998277 0.524318 1.02 0.614759L2.5 5.99976L1 11.3698C0.979616 11.4453 0.977237 11.5245 0.993055 11.6012C1.00887 11.6778 1.04245 11.7496 1.09108 11.8109C1.13972 11.8722 1.20205 11.9212 1.27307 11.954C1.34409 11.9868 1.42182 12.0025 1.5 11.9998C1.57827 11.9993 1.65534 11.9804 1.725 11.9448L12.725 6.44476C12.8069 6.4028 12.8756 6.33905 12.9236 6.26054C12.9716 6.18202 12.997 6.09178 12.997 5.99976C12.997 5.90774 12.9716 5.8175 12.9236 5.73898C12.8756 5.66047 12.8069 5.59672 12.725 5.55476ZM2.275 10.5548L3.38 6.49976H8V5.49976H3.38L2.275 1.44476L11.38 5.99976L2.275 10.5548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.55a87232fd516927b7ed7e7f880f2c4a.svg";
export { ForwardRef as ReactComponent };